import { useState } from 'react';

export default function ProductShowcase() {
  const [activeCategory, setActiveCategory] = useState('trending');

  const categories = [
    { id: 'trending', label: 'Trending Now', icon: 'ri-fire-line' },
    { id: 'electronics', label: 'Electronics', icon: 'ri-smartphone-line' },
    { id: 'fashion', label: 'Fashion', icon: 'ri-shirt-line' },
    { id: 'home', label: 'Home & Living', icon: 'ri-home-line' }
  ];

  const products = [
    {
      name: 'Wireless Noise-Cancelling Headphones Pro',
      price: 299.99,
      rating: 4.8,
      reviews: 2847,
      image: 'https://public.readdy.ai/ai/img_res/cb91585dbb04c0f5095c304f22a21ec8.jpg',
      badge: 'Best Seller',
      category: 'trending'
    },
    {
      name: 'Smart Watch Series 8 - Fitness Tracker',
      price: 399.99,
      rating: 4.9,
      reviews: 3521,
      image: 'https://readdy.ai/api/search-image?query=Modern%20smartwatch%20with%20vibrant%20AMOLED%20display%20showing%20fitness%20metrics%2C%20sleek%20aluminum%20case%20with%20sport%20band%2C%20professional%20product%20photography%20on%20clean%20white%20background%2C%20premium%20wearable%20technology&width=400&height=400&seq=prod-002&orientation=squarish',
      badge: 'New Arrival',
      category: 'electronics'
    },
    {
      name: 'Ultra-Slim Laptop 15.6" - 16GB RAM',
      price: 1299.99,
      rating: 4.7,
      reviews: 1893,
      image: 'https://readdy.ai/api/search-image?query=Sleek%20ultra-thin%20laptop%20computer%20with%20metallic%20silver%20finish%2C%20open%20display%20showing%20modern%20interface%2C%20professional%20product%20photography%20on%20clean%20white%20background%2C%20premium%20business%20technology&width=400&height=400&seq=prod-003&orientation=squarish',
      badge: 'Top Rated',
      category: 'electronics'
    },
    {
      name: 'Designer Leather Crossbody Bag',
      price: 189.99,
      rating: 4.6,
      reviews: 1247,
      image: 'https://readdy.ai/api/search-image?query=Elegant%20leather%20crossbody%20handbag%20in%20cognac%20brown%20color%2C%20premium%20craftsmanship%20with%20gold%20hardware%2C%20professional%20product%20photography%20on%20clean%20white%20background%2C%20luxury%20fashion%20accessory&width=400&height=400&seq=prod-004&orientation=squarish',
      badge: 'Limited',
      category: 'fashion'
    },
    {
      name: 'Minimalist Ceramic Coffee Maker',
      price: 149.99,
      rating: 4.8,
      reviews: 2156,
      image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20ceramic%20coffee%20maker%20in%20matte%20white%20finish%2C%20sleek%20Scandinavian%20design%2C%20professional%20product%20photography%20on%20clean%20white%20background%2C%20premium%20kitchen%20appliance&width=400&height=400&seq=prod-005&orientation=squarish',
      badge: 'Eco-Friendly',
      category: 'home'
    },
    {
      name: 'Premium Yoga Mat with Alignment Marks',
      price: 79.99,
      rating: 4.9,
      reviews: 3842,
      image: 'https://readdy.ai/api/search-image?query=High-quality%20yoga%20mat%20in%20deep%20purple%20color%20with%20alignment%20guide%20marks%2C%20rolled%20and%20partially%20unrolled%2C%20professional%20product%20photography%20on%20clean%20white%20background%2C%20premium%20fitness%20equipment&width=400&height=400&seq=prod-006&orientation=squarish',
      badge: 'Best Seller',
      category: 'trending'
    },
    {
      name: 'Wireless Charging Station 3-in-1',
      price: 89.99,
      rating: 4.7,
      reviews: 1654,
      image: 'https://readdy.ai/api/search-image?query=Sleek%20wireless%20charging%20dock%20station%20in%20black%20with%20multiple%20device%20slots%2C%20modern%20minimalist%20design%2C%20professional%20product%20photography%20on%20clean%20white%20background%2C%20premium%20tech%20accessory&width=400&height=400&seq=prod-007&orientation=squarish',
      badge: 'Trending',
      category: 'electronics'
    },
    {
      name: 'Organic Cotton Oversized Hoodie',
      price: 69.99,
      rating: 4.8,
      reviews: 2973,
      image: 'https://readdy.ai/api/search-image?query=Comfortable%20oversized%20hoodie%20in%20soft%20beige%20color%2C%20organic%20cotton%20fabric%2C%20laid%20flat%20display%2C%20professional%20product%20photography%20on%20clean%20white%20background%2C%20sustainable%20fashion%20apparel&width=400&height=400&seq=prod-008&orientation=squarish',
      badge: 'Sustainable',
      category: 'fashion'
    }
  ];

  const filteredProducts = products.filter(p => p.category === activeCategory);

  return (
    <section id="products" className="py-24 bg-gradient-to-br from-gray-50 to-white" data-product-shop>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-indigo-50 px-4 py-2 rounded-full mb-4">
            <i className="ri-shopping-bag-line text-indigo-600"></i>
            <span className="text-sm font-semibold text-indigo-600">MARKETPLACE</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Discover Amazing Products
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Browse through millions of products curated by our AI to match your preferences and needs.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`px-6 py-3 rounded-xl font-semibold transition-all cursor-pointer whitespace-nowrap flex items-center space-x-2 ${
                activeCategory === category.id
                  ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
              }`}
            >
              <i className={`${category.icon} text-lg`}></i>
              <span>{category.label}</span>
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
          {filteredProducts.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition-all group border border-gray-100"
            >
              <div className="relative overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-indigo-600 text-white text-xs font-semibold rounded-full">
                    {product.badge}
                  </span>
                </div>
                <button className="absolute top-4 right-4 w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-lg opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer">
                  <i className="ri-heart-line text-gray-700 text-lg"></i>
                </button>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">{product.name}</h3>
                <div className="flex items-center space-x-2 mb-3">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-${i < Math.floor(product.rating) ? 'fill' : 'line'} text-yellow-400 text-sm`}
                      ></i>
                    ))}
                  </div>
                  <span className="text-sm text-gray-600">({product.reviews})</span>
                </div>
                <div className="flex items-center justify-between">
                  <div className="text-2xl font-bold text-indigo-600">${product.price}</div>
                  <button className="px-4 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:shadow-lg transition-all cursor-pointer whitespace-nowrap flex items-center space-x-1">
                    <i className="ri-shopping-cart-line"></i>
                    <span className="text-sm font-medium">Add</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="px-8 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl hover:shadow-lg transition-all font-semibold cursor-pointer whitespace-nowrap inline-flex items-center space-x-2">
            <span>View All Products</span>
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
